import React from 'react';
import { Center, Icon, Tooltip } from '@chakra-ui/react';
import { DocumentDuplicateIcon } from '@heroicons/react/solid';

type Props = {
  /**
   * The text to be copied when the button is clicked.
   */
  copyText?: string;
  /**
   * A function that returns the text to be copied when the button is clicked.
   */
  onCopyText?: () => string
};

export function CopyButton({ copyText, onCopyText }: Props): JSX.Element {
  const [copied, setCopied] = React.useState(false);
  const handleClick = () => {
    const text = onCopyText?.() ?? (copyText || '');
    navigator.clipboard.writeText(text);
    setCopied(true);
  };

  React.useEffect(() => {
    let timer: NodeJS.Timeout;

    if (copied) {
      timer = setTimeout(() => {
        setCopied(false);
      }, 1000);
    }

    return () => clearTimeout(timer);
  }, [copied, setCopied]);

  return (
    <Tooltip
      label={copied ? 'Copied' : 'Copy'}
      aria-label="Copy to clipboard"
      closeOnClick={false}
    >
      <Center as="button">
        <Icon as={DocumentDuplicateIcon} boxSize={5} onClick={handleClick} />
      </Center>
    </Tooltip>
  );
}
